// A person with no email address can never sign in — there's nowhere to send an
// invite or a reset link. They're a contact record, not an account, and that
// distinction is invisible otherwise: the row looks identical to someone who
// simply hasn't accepted their invite yet.
//
// Emails became optional in migration 0012, so this is now a normal state
// rather than bad data. Adding an address is all it takes to turn one of these
// into a real login.

export default function InfoOnlyBadge({ className = '' }) {
  return (
    <span
      title="No email on file, so this person can't sign in. Add one to invite them."
      className={
        'inline-block shrink-0 text-[11px] font-medium px-2 py-0.5 rounded-full ' +
        'bg-ink-100 text-ink-500 uppercase tracking-wide ' +
        className
      }
    >
      Information only
    </span>
  );
}
